function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M82.0137 232.592C36.7914 229.768 2.29753 190.679 5.12155 145.457L9.08342 82.0137C11.9074 36.7913 50.9963 2.29752 96.2186 5.12153C141.441 7.94555 175.935 47.0344 173.111 92.2567L169.149 155.7C166.325 200.923 127.236 235.416 82.0137 232.592Z",
  fill: "#9B8AFB"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M162.218 91.5768C164.671 52.2975 134.818 18.4669 95.5384 16.0141C56.2591 13.5612 22.4285 43.4148 19.9757 82.6941L16.0138 146.138C13.5609 185.417 43.4146 219.247 82.6938 221.7C121.973 224.153 155.804 194.299 158.257 155.02L162.218 91.5768Z",
  stroke: "#111927",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M148.1 88.8137L33.5565 81.6608C29.5292 81.4093 26.0605 84.4702 25.809 88.4975L25.8079 88.5159C25.5564 92.5432 28.6173 96.0119 32.6446 96.2634L147.188 103.416C151.216 103.668 154.684 100.607 154.936 96.5796L154.937 96.5612C155.188 92.5339 152.127 89.0652 148.1 88.8137Z",
  stroke: "#111927",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M108.531 128.349L108.369 130.939C108.331 130.07 108.385 129.207 108.531 128.349Z",
  fill: "#111927"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M123.79 107.524C118.537 107.196 113.576 108.675 109.515 111.409C109.341 111.527 109.187 111.628 109.014 111.746C96.6942 119.754 80.5853 118.748 69.3574 109.27C69.2001 109.131 69.06 109.012 68.9027 108.873C65.2129 105.655 60.475 103.571 55.2217 103.242C42.5661 102.452 31.6571 112.079 30.8656 124.753C30.0742 137.427 39.7019 148.317 52.3575 149.108C57.6843 149.44 62.7021 147.928 66.7866 145.122C78.7598 137.056 94.4714 137.631 105.767 146.321C109.627 150.361 114.938 153.016 120.926 153.39C133.581 154.18 144.49 144.553 145.281 131.898C146.071 119.242 136.445 108.315 123.79 107.524ZM63.054 136.683C57.258 141.798 48.4045 141.245 43.2899 135.449C38.1764 129.635 38.7281 120.8 44.5241 115.685C50.3201 110.57 59.1735 111.123 64.2882 116.919C69.4029 122.715 68.8511 131.55 63.054 136.683ZM131.622 140.965C125.826 146.08 116.973 145.527 111.858 139.731C109.638 137.195 108.468 134.08 108.367 130.975L108.369 130.939C108.331 130.07 108.385 129.206 108.531 128.349C108.514 128.311 108.516 128.293 108.536 128.257C109.025 125.153 110.555 122.206 113.092 119.967C118.888 114.852 127.742 115.405 132.856 121.201C137.971 126.997 137.419 135.832 131.622 140.965Z",
  fill: "#111927"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M59.961 133.355C55.9994 136.851 49.9563 136.474 46.4421 132.511C45.2711 131.184 44.5386 129.626 44.2331 128.021L50.7582 125.995L44.5359 123.172C45.0398 121.599 45.9593 120.163 47.2863 118.992C51.2674 115.479 57.3105 115.856 60.8052 119.836C64.3195 123.799 63.941 129.86 59.961 133.355Z",
  fill: "#111927"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M108.531 128.349L108.369 130.939C108.331 130.07 108.385 129.207 108.531 128.349Z",
  fill: "#111927"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M108.531 128.349L108.369 130.939C108.331 130.07 108.385 129.207 108.531 128.349Z",
  fill: "#9B8AFB"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M128.529 137.637C124.568 141.133 118.525 140.755 115.01 136.793C113.839 135.466 113.107 133.908 112.801 132.303L119.326 130.276L113.104 127.454C113.608 125.881 114.528 124.445 115.855 123.274C119.836 119.761 125.879 120.138 129.373 124.118C132.888 128.081 132.509 134.142 128.529 137.637Z",
  fill: "#111927"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M59.961 133.355C55.9994 136.851 49.9563 136.474 46.4421 132.511C45.2711 131.184 44.5386 129.626 44.2331 128.021L50.7582 125.995L44.5359 123.172C45.0398 121.599 45.9593 120.163 47.2863 118.992C51.2674 115.479 57.3105 115.856 60.8052 119.836C64.3195 123.799 63.941 129.86 59.961 133.355Z",
  fill: "#9B8AFB"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M59.961 133.355C55.9994 136.851 49.9563 136.474 46.4421 132.511C45.2711 131.184 44.5386 129.626 44.2331 128.021L50.7582 125.995L44.5359 123.172C45.0398 121.599 45.9593 120.163 47.2863 118.992C51.2674 115.479 57.3105 115.856 60.8052 119.836C64.3195 123.799 63.941 129.86 59.961 133.355Z",
  fill: "#111927"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M52.2853 171.525L56.8429 171.183C56.7465 172.726 57.5525 173.698 58.8199 173.777C59.8117 173.839 60.4879 173.347 60.5372 172.557C60.5842 171.804 60.1353 171.315 58.9448 170.89L57.3755 170.331C54.2138 169.285 52.9142 167.655 53.084 164.937C53.2859 161.704 55.5967 159.838 59.4173 160.077C61.0888 160.181 62.4205 160.707 63.4147 161.617C64.4089 162.528 64.8854 163.756 64.8464 165.266L60.445 165.765C60.5242 164.498 59.949 163.669 59.0673 163.614C58.3142 163.567 57.7494 164.048 57.7024 164.801C57.6554 165.554 58.1226 166.044 59.4222 166.494L60.9376 167.032C64.0958 168.132 65.3805 169.706 65.2142 172.37C65.0077 175.676 62.4673 177.675 58.4079 177.421C54.6425 177.186 52.2545 174.972 52.3393 171.547L52.2853 171.525Z",
  fill: "#111927"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M66.8119 169.224C67.1423 163.934 70.2922 160.738 74.8475 161.023C78.7416 161.266 81.3362 164.009 81.4466 168.147L76.8202 168.411C76.6823 166.485 75.8339 165.307 74.6216 165.231C73.0419 165.133 71.9445 166.76 71.7725 169.516C71.6004 172.271 72.6394 173.94 74.4763 174.055C76.0375 174.152 77.2383 172.936 77.6411 170.915L82.2343 171.773C81.4723 176.004 78.359 178.612 74.2078 178.353C69.377 178.051 66.4678 174.44 66.7959 169.186L66.8119 169.224Z",
  fill: "#111927"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M87.5112 162.274L93.6829 162.66L97.1944 179.364L92.1983 179.052L91.7527 176.148L87.6566 175.892L86.798 178.715L81.9672 178.413L87.5296 162.276L87.5112 162.274ZM91.4127 172.734L90.3826 166.492L90.3459 166.49L88.4187 172.547L91.4311 172.735L91.4127 172.734Z",
  fill: "#111927"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M99.8363 163.044L106.504 163.46L108.842 174.449L108.897 174.452L112.621 163.842L119.251 164.256L118.226 180.678L113.762 180.399L114.45 169.396L114.413 169.394L110.42 180.19L106.617 179.953L104.053 168.747L104.016 168.745L103.329 179.747L98.866 179.469L99.8914 163.048L99.8363 163.044Z",
  fill: "#111927"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M57.509 181.182L67.2258 181.789L66.9619 186.014L62.223 185.718L62.0417 188.62L65.4031 188.83L65.1726 192.522L61.8112 192.312L61.4613 197.914L56.4836 197.604L57.509 181.182Z",
  fill: "#111927"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M69.1545 181.909L75.7303 182.32C79.8815 182.579 82.1994 184.734 81.9895 188.095C81.8759 189.914 80.9427 191.275 79.3585 191.84C80.5696 192.229 81.1425 193.095 81.0576 194.454L80.7674 199.101L75.7897 198.79L76.0661 194.364C76.1189 193.519 75.6792 192.883 74.9628 192.838L73.4566 192.744L73.0896 198.622L68.1118 198.311L69.1373 181.89L69.1545 181.909ZM75.0717 189.618C76.1922 189.688 76.9544 188.998 77.0244 187.877C77.0989 186.684 76.4273 185.922 75.3068 185.852L73.9109 185.765L73.6757 189.531L75.0717 189.618Z",
  fill: "#111927"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M84.3083 182.856L94.0434 183.464L93.8014 187.339L88.842 187.029L88.686 189.528L92.727 189.78L92.5182 193.123L88.4772 192.871L88.3029 195.662L93.4827 195.986L93.2395 199.88L83.2656 199.257L84.2911 182.836L84.3083 182.856Z",
  fill: "#111927"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M96.2475 183.601L105.983 184.209L105.741 188.085L100.781 187.775L100.625 190.273L104.666 190.526L104.457 193.869L100.416 193.616L100.242 196.408L105.422 196.732L105.179 200.626L95.2048 200.003L96.2303 183.582L96.2475 183.601Z",
  fill: "#111927"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M107.076 198.587C107.164 197.191 108.255 196.245 109.706 196.335C111.157 196.426 112.141 197.502 112.054 198.898C111.967 200.293 110.875 201.24 109.406 201.148C107.936 201.056 106.989 199.983 107.076 198.587ZM107.944 188.831L108.225 184.331L112.688 184.609L112.407 189.11L110.867 195.467L108.681 195.331L107.944 188.831Z",
  fill: "#111927"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M144.867 88.6122C146.768 58.1763 123.639 31.9858 93.2212 30.0863C62.8036 28.1868 36.5764 51.3136 34.6769 81.7312",
  stroke: "#111927",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgSignScamfreeHardcoded(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 179,
    height: 238,
    viewBox: "0 0 179 238",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignScamfreeHardcoded);
export default __webpack_public_path__ + "static/media/Sign_scamfree_hardcoded.f4b579e5.svg";
export { ForwardRef as ReactComponent };